// extracted by mini-css-extract-plugin
export default {"header":"style_header__NytZf","logo":"style_logo__CNbzv","logoImage":"style_logoImage__UJeSk"};